import { Component, Input, OnInit } from '@angular/core';
import { BrowserDetectionService } from 'src/app/_services/browser-detection.service';

@Component({
  selector: 'app-browser-detection',
  templateUrl: './browser-detection.component.html',
  styleUrls: ['./browser-detection.component.scss']
})
export class BrowserDetectionComponent implements OnInit {

  @Input() title: string = '';

  browser: string = '';

  constructor(
    private browserDetectionService: BrowserDetectionService
  ) 
  {}

  ngOnInit() {
    this.browser = this.browserDetectionService.getBrowserName();
  }

}
